// Tamanho de arquivo legível (PO1-2859). Mesma regra da cópia local em
// views/Empresa/Importacao/index.js; extraída para reuso pelos anexos da tabela de frete.
export function formatBytes(value) {
  if (value == null || Number.isNaN(Number(value))) return "-";
  const n = Number(value);
  if (n < 1024) return n + " B";
  if (n < 1024 * 1024) return (n / 1024).toFixed(1) + " KB";
  return (n / (1024 * 1024)).toFixed(1) + " MB";
}

export default formatBytes;
